<ng-container *ngIf="typeAccountSignal() !== 'noAccount'; else notAttach">
  @if (messagesFromProgPerso?.message) {
  <div class="fx-direction-row fx-center">
    <mat-card appearance="outlined" class="card-info">
      <mat-card-title class="fx-direction-row fx-between-center">
        @if (messagesFromProgPerso.type === "message") {
        <div class="fx-direction-row fx-start-center accent">
          <mat-icon color="accent" style="margin-right: 10px;">info</mat-icon>
          <span>{{'comptes_user.card_title_prog_perso_message' | trans}}</span>
        </div>
        }@else {
        <div class="fx-direction-row fx-start-center mat-error">
          <mat-icon color="warn" style="margin-right: 10px;">error</mat-icon>
          <span>{{'comptes_user.card_title_prog_perso_error' | trans}}</span>
        </div>
        }
      </mat-card-title>
      <mat-card-content>
        <pre [innerHTML]="messagesFromProgPerso.message | safe"
          style="text-align: left; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;"></pre>
      </mat-card-content>
    </mat-card>
  </div>
  }

  <app-board *ngIf="boardCards && accountVars && !loading; else loader"
    [boardCards]="filterBoardCardsByEtablissements()" [compact]="(platformService.isSmall$ | async)"
    [variables]="accountVars"></app-board>
</ng-container>


<ng-template #notAttach>
  <div class="fx-direction-row fx-center-center">
    <mat-icon color="warn" style="margin-right: 5px;">warning</mat-icon>
    <h3>{{'login.no_account_err_message'|trans}}</h3>
  </div>
</ng-template>


<ng-template #loader>
  <app-loader class="margin" message="Chargement du compte..."></app-loader>
</ng-template>